import { fileDao } from '../dao/file-dao'
import { queryKeys } from '../util/query-keys'
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

export const useImageFile = (
  fileId: string | undefined,
  options?: Omit<UseQueryOptions<string, Error>, 'queryKey' | 'queryFn'>,
): UseQueryResult<string, Error> => {
  return useQuery<string, Error>(queryKeys.imageFile(fileId || ''), () => fileDao.downloadBase64FileByFileId(fileId!), {
    enabled: !!fileId && fileId.trim() !== '',
    ...options,
  })
}
